import { QuickLink } from 'src/app/models/quick-link-model';

export abstract class QuickLinks {
    readonly recentMaxCount = 5;
    shared = [];
    pinned = [];
    recent = [];

    get sharedAndPinned(): QuickLink[] {
        return this.shared.concat(this.pinned);
    }

    set(quickLinks: QuickLink[]): void {
        this.shared = quickLinks.filter(f => f.isShared);
        this.pinned = quickLinks.filter(f => !f.isShared).filter(f => f.isPinned);
        this.recent = quickLinks.filter(f => !f.isShared).filter(f => !f.isPinned);
    }

    addRecent(quickLink: QuickLink): void {
        this.recent.unshift(quickLink); // Place this new filter at the head of the array
        this.recent.length = this.recent.length <= this.recentMaxCount ? this.recent.length : this.recentMaxCount; // Remove the last (oldest) filter since we only want the 5 most recent
    }

    getSharedAndPinnedDeepCopy(): QuickLink[] {
        return this.sharedAndPinned.map(ql => Object.assign(new QuickLink(), ql));
    }

    getRecentDeepCopy(): QuickLink[] {
        return this.recent.map(ql => Object.assign(new QuickLink(), ql));
    }
}
